<template>
    <div>
        <div class="flex gap-2 items-center">
            <span class="text-lg">{{ $t('Progress') }}</span>
            <span class="text-sm text-gray-500">{{ $t('click for emails') }}</span>
        </div>

        <div class="relative mt-4 h-[46px] group">
            <div class="absolute h-[46px] top-0 left-0 flex items-center w-full">
                <div class="w-0 h-[4px] bg-primary-100 inline-block transition-all ease-out delay-200 duration-700"
                    :class="[animate_in ? 'w-[50%]' : '']">
                </div>
                <div class="w-full h-[4px] bg-gray-100 inline-block transition-all ease-out delay-200 duration-700"
                    :class="[animate_in ? '!w-0' : '']">
                </div>
            </div>
            <ol class="absolute top-0 left-0 flex items-center w-full justify-between">
                <li type="button" @click="open('formdetails')" role="presentation" class="flex md:w-full items-center flex items-center justify-center w-10 h-10 rounded-full lg:h-12 lg:w-12 shrink-0 
                        bg-gray-100 text-gray-500 hover:bg-gray-200 transition hover:scale-105 cursor-pointer"
                        :class="[1 ? 'bg-primary-50 text-primary hover:bg-primary-100 border border-primary' : '', animate_in ? 'scale-100': 'scale-90']">
                    <svg class="w-4 h-4 lg:w-5 lg:h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor" viewBox="0 0 20 16">
                        <path
                            d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z" />
                    </svg>
                </li>
                <li type="button" @click="open('payment')" role="presentation" class="flex md:w-full items-center justify-center flex items-center justify-center w-10 h-10 rounded-full lg:h-12 lg:w-12 shrink-0 
                        bg-gray-100 text-gray-500 hover:bg-gray-200 transition hover:scale-105 cursor-pointer"
                    :class="[paymenthappened ? 'bg-primary-50 text-primary hover:bg-primary-100 border border-primary' : '', animate_in ? 'scale-100': 'scale-90']">
                    <svg class="w-4 h-4 mr-1 lg:w-5 lg:h-5" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                        viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M48.1 240c-.1 2.7-.1 5.3-.1 8l0 16c0 2.7 0 5.3 .1 8L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.3 0C89.9 419.9 170 480 264 480l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0c-57.9 0-108.2-32.4-133.9-80L256 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-143.8 0c-.1-2.6-.2-5.3-.2-8l0-16c0-2.7 .1-5.4 .2-8L256 240c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.9 0c25.7-47.6 76-80 133.9-80l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0C170 32 89.9 92.1 60.3 176L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l16.1 0z" />
                    </svg>
                </li>
                <li type="button" @click="open('confirmation')" role="presentation" class="flex md:w-full items-center justify-center flex items-center justify-center w-10 h-10 rounded-full lg:h-12 lg:w-12 shrink-0 
                    bg-gray-100 text-gray-500 hover:bg-gray-200 transition hover:scale-105 cursor-pointer"
                    :class="[confirmationSent ? 'bg-primary-50 text-primary hover:bg-primary-100 border border-primary' : '', animate_in ? 'scale-100': 'scale-90']">
                    <svg-vue icon="envelope" class="w-5 h-5 lg:w-5 lg:h-5"></svg-vue>
                </li>
                <li type="button" @click="open('checkin')" role="presentation"
                    class="flex md:w-full items-center justify-center flex items-center justify-center w-10 h-10 rounded-full lg:h-12 lg:w-12 shrink-0
                                        bg-gray-100 text-gray-500 hover:bg-gray-200 transition hover:scale-105 cursor-pointer"
                    :class="[checkinhappened ? 'bg-primary-50 text-primary hover:bg-primary-100 border border-primary' : '', animate_in ? 'scale-100': 'scale-90']">
                    <svg-vue icon="plane-arrive" class="w-5 h-5 lg:w-5 lg:h-5"></svg-vue>
                </li>
                <li type="button" @click="open('checkout')" role="presentation"
                    class="flex items-center justify-end md:w-full flex items-center justify-center w-10 h-10 rounded-full lg:h-12 lg:w-12 shrink-0
                                        bg-gray-100 text-gray-500 hover:bg-gray-200 transition hover:scale-105 cursor-pointer"
                    :class="[checkouthappened ? 'bg-primary-50 text-primary hover:bg-primary-100 border border-primary' : '', animate_in ? 'scale-100': 'scale-90']">
                    <svg-vue icon="plane-departure" class="w-5 h-5 lg:w-5 lg:h-5"></svg-vue>
                </li>
            </ol>
        </div>
        <transition name="fade">
            <div v-show="modalActive" @click.self="closeModal" @keydown.esc="closeModal"
                class="bg-black bg-opacity-20 backdrop-blur z-50 fixed top-0 left-0 h-full w-full flex  justify-center animate-in fade-in duration-300 items-center py-8 overflow-y-scroll overflow-x-hidden scrollbar-hide js_close_clickable">
                <transition name="fade">
                    <div v-show="modalActive" class="w-full h-full flex gap-8 justify-center items-center"
                        @click.self="closeModal">

                        <iframe class="w-[400px] h-[932px] max-h-[90vh] max-w[100vw] bg-white rounded-3xl shadow-2xl" :srcdoc="emailContent"></iframe>

                        <div class="relative bg-white rounded-3xl md:rounded-lg shadow  max-h-full overflow-y-scroll scrollbar-hide">
                            <!-- Modal header -->
                            <div class="flex items-start justify-between p-5 border-b rounded-t">
                                <h3 class="text-xl font-semibold text-gray-900">
                                    {{ title }}
                                </h3>
                                <button id="closeButton" @click.self="closeModal" type="button"
                                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                                    <svg class="w-5 h-5 pointer-events-none" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                            <!-- Modal body -->
                            <div class="px-6 ignore-css">
                            </div>
                            <!-- Modal footer -->
                            <div class="flex items-center justify-between p-6 space-x-2 border-t border-gray-200 rounded-b">

                                <button type="button" @click.self="closeModal"
                                    class="text-gray-500 bg-white duration-150 transition  hover:scale-105 hover:shadow-lg focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
                                    {{ $t('Close') }}</button>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            emailFile: "",
            emailContent: "",
            modalActive: this.$attrs.modalActive ?? false,
            booking: JSON.parse(this.$attrs.booking) ?? [],
            logs : JSON.parse(this.$attrs.logs) ?? [],
            payments : JSON.parse(this.$attrs.payment) ?? [],
            paymenthappened: false,
            confirmationSent: false,
            checkinhappened: false,
            checkouthappened: false,
            animate_in: false,
        };
    },

    created() {

        var paid = 0;
        for(var i in this.payments) {
            paid += this.payments[i].amount
        }

        if (paid == this.booking.price) { 
            this.paymenthappened = true;
        }

        for (var i in this.logs) {
            if (this.logs[i].name == 'bookingConfirmation') {
                this.confirmationSent = true;
            }

            if (this.logs[i].name == 'bookingCheckin') {
                this.checkinhappened = true;
            }


            if (this.logs[i].name == 'bookingCheckout') {
                this.checkouthappened = true;
            }
        }
    },

    mounted() {
        setTimeout(() => {
            this.animate_in = true;
        }, 100);
    },

    methods: {
        async open(type) {
            switch (type) {
                case 'formdetails':
                    this.title = this.$t("Form Details");
                    break;
                case 'payment':
                    this.title = this.$t("Payment Request Message");
                    break;
                case 'confirmation':
                    this.title = this.$t("Confirmation Message");
                    this.emailFile = 'sendConfirmationEmail';
                    break;
                case 'checkin':
                    this.title = this.$t("Checkin Message");
                    this.emailFile = 'sendCheckinEmail';
                    break;
                case 'checkout':
                    this.title = this.$t("Checkout Message");
                    break;
                default:
                    this.title = this.$t("Something went wrong");
                    break;
            }

            let response = await fetch(
                window.location.origin + "/api/email/"+this.booking.id+"/" + this.emailFile,
                {
                    method: 'GET',
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                }
            );
            const content = await response.text();
            this.emailContent = content;

            $("body").addClass("scroll_lock")
            this.modalActive = true;
        },
        closeModal() {
            this.modalActive = false;
            setTimeout(function () {
                $("body").removeClass("scroll_lock")
            }, 200);
        }
    }
};
</script>
